const checkForError = (errors = []) => {
  const {
    message: errMsg
  } = errors.find((err = {}) => err && err.message) || {};
  return {
    hasErr: !!errMsg,
    errMsg
  };
};
export default checkForError;
//# sourceMappingURL=check-for-error.js.map